import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { SpecialtyIntakeService, SpecialtyIntakeField } from '../../../services/specialty-intake.service';
import { canShowLbsToKgConversion, formatWeightDisplay } from '../../../common/weight-display';

@Component({
  selector: 'app-specialty-intake-display',
  templateUrl: './specialty-intake-display.component.html',
  styleUrls: ['./specialty-intake-display.component.scss'],
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule]
})
export class SpecialtyIntakeDisplayComponent implements OnInit, OnChanges {

  @Input() appointmentForm: any;
  @Input() appointmentDetails: any;
  @Input() editEnabled: boolean = false; // Whether edit mode is active

  specialtyType: string = '';
  specialtyIntakeFields: SpecialtyIntakeField[] = [];

  constructor(public specialtyIntakeService: SpecialtyIntakeService) { }

  ngOnInit(): void {
    this.setupSpecialtyDisplay();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Re-setup when appointmentDetails or appointmentForm changes
    if (changes['appointmentDetails'] || changes['appointmentForm']) {
      this.setupSpecialtyDisplay();
    }
  }

  private setupSpecialtyDisplay(): void {
    if (this.appointmentDetails?.specialtyIntakeData && this.appointmentForm) {
      this.specialtyType = this.specialtyIntakeService.getSpecialtyType(this.appointmentDetails);

      this.specialtyIntakeFields = this.specialtyIntakeService.addSpecialtyIntakeFieldsToForm(
        this.appointmentForm,
        this.appointmentDetails.specialtyIntakeData
      );
    }
  }

  // Delegate methods to service for template use
  hasSpecialtyIntakeData(): boolean {
    return this.specialtyIntakeService.hasSpecialtyIntakeData(this.appointmentDetails);
  }

  isLongTextField(fieldName: string): boolean {
    return this.specialtyIntakeService.isLongTextField(fieldName, this.specialtyType);
  }

  getFieldMaxLength(fieldName: string): number {
    return this.specialtyIntakeService.getFieldMaxLength(fieldName, this.specialtyType);
  }

  formatArrayValue(value: any): string {
    return this.specialtyIntakeService.formatArrayValue(value);
  }

  shouldShowUpdatedWeightConversion(fieldName: string): boolean {
    if (fieldName !== 'updatedWeight' || !this.appointmentForm) {
      return false;
    }

    return canShowLbsToKgConversion(
      this.appointmentForm.get('updatedWeight')?.value,
      this.appointmentForm.get('updatedWeightUnit')?.value
    );
  }

  getUpdatedWeightDisplay(fieldName: string): string {
    if (fieldName !== 'updatedWeight' || !this.appointmentForm) {
      return '';
    }

    return formatWeightDisplay(
      this.appointmentForm.get('updatedWeight')?.value,
      this.appointmentForm.get('updatedWeightUnit')?.value
    );
  }
}
